import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.PricingFeeTypes')
export class PricingFeeTypes extends AbstractModel {
  @JsonProperty([String], 'anchors')
  anchors?: string[]

  @JsonProperty([String], 'types')
  types?: string[]
}

